import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	position: relative;
	width: 100%;
`;

export const doubtConatiner = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	cursor: help;
	z-index: 10;
	> svg {
		font-size: 1.5rem;
		color: rgb(108, 117, 125);
	}
`;

export const inputImg = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 0.5rem;

	> p {
		font-weight: 700;
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
	}

	> input {
		display: none;
	}
`;

export const labelWithImage = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	> label {
		min-height: 40px;
		max-height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: ${color.interface.lightGray};
		width: 100%;
		cursor: pointer;
		padding: 0.5rem 2rem 0.5rem 1rem;
		border-radius: 5px;
		border: 1px solid ${color.interface.lightGray2};
	}

	> svg {
		font-size: 40px;
		border-radius: 5px;
	}
`;

export const deleteBtnFromBackBtn = styled.div`
	position: absolute;
	top: 10px;
	right: 10px;
	cursor: pointer;
	z-index: 10;
	background-color: ${color.interface.white};
	width: 38px;
	height: 38px;
	border-radius: 25px;
	display: flex;
	align-items: center;
	justify-content: center;

	-webkit-box-shadow: 0px 0px 34px -11px rgba(0, 0, 0, 0.75);
	-moz-box-shadow: 0px 0px 34px -11px rgba(0, 0, 0, 0.75);
	box-shadow: 0px 0px 34px -11px rgba(0, 0, 0, 0.75);
`;

export const imageLoadead = styled.div<{ $imgHeight: number }>`
	position: relative;
	width: 100%;
	height: ${(props) => `${props.$imgHeight}px`};
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${color.interface.lightGray2};

	> img {
		width: 98%;
		height: 100%;
		border-radius: 5px !important;
		object-fit: contain;
	}
`;

export const unselectImg = styled.div<{ $isShowBtnUnselect: boolean }>`
	position: absolute;
	cursor: pointer;
	width: 100%;
	height: 100%;
	display: ${(props) => (props.$isShowBtnUnselect ? 'flex' : 'none')};
	align-items: center;
	justify-content: center;
	background-color: rgba(52, 58, 64, 0.8);

	> p {
		color: ${color.interface.white};
		font-size: 1.4rem;
	}
`;

export const noImage = styled.div<{ $imgHeight: number }>`
	position: relative;
	width: 100%;
	height: ${(props) => `${props.$imgHeight}px`};
	border: 4px dotted ${color.interface.lightGray2};
	padding: 1rem;

	> svg {
		font-size: 15px;
		color: ${color.interface.white};
	}
`;

export const infoWidth = styled.div`
	position: absolute;
	top: 5px;
	left: 50%;

	> p {
		transform: translateX(-50%);
		font-size: 1.5rem;
		color: ${color.interface.lightGray};
	}
`;

export const infoheight = styled.div`
	position: absolute;
	left: 5px;
	top: 50%;
	transform: translateY(-50%);
	> p {
		font-size: 1.5rem;
		color: ${color.interface.lightGray};
	}
`;
export const errorMessage = styled.span`
	color: ${color.interface.red};
	font-size: 1.2rem;
`;
